'use strict';

$.fn.extend({
  externalLinks: function (options) {
    return this.each(function () {
      // attach real href on hover to avoid indexing by bots that execute
      // javascript
      $(this).find('.js-external-link').each(function () {
        var $link = $(this);
        var userAction = 'hover focus click';
        $link.attr('href', '#').removeClass('js-external-link');

        var attachHref = function () {
          $link.attr('href', $link.attr('data-href'));
          $link.removeAttr('data-href');
          return $link.off(userAction, attachHref);
        };

        return $link.on(userAction, attachHref);
      });
    });
  }
});
